import { render, staticRenderFns } from "./TriggerResponsible.vue?vue&type=template&id=52e5b5e3&scoped=true&"
import script from "./TriggerResponsible.vue?vue&type=script&lang=js&"
export * from "./TriggerResponsible.vue?vue&type=script&lang=js&"
import style0 from "./TriggerResponsible.vue?vue&type=style&index=0&id=52e5b5e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e5b5e3",
  null
  
)

export default component.exports